import {takeLatest} from 'redux-saga/effects';
import * as saga from './saga';
import * as ACTION from './constants';

export default function*() {
    yield takeLatest(ACTION.UPDATE_COMPLAINT_SELLER_SUCCESS.REQUEST, saga.updateComplaintSellerSuccess);
    yield takeLatest(ACTION.UPDATE_COMPLAINT_SELLER_SUCCESS.SUCCESS, saga.onUpdateComplaintSellerSuccess);
}
